import { render, staticRenderFns } from "./SgQuickPaySuccess.vue?vue&type=template&id=6aa83643&"
import script from "./SgQuickPaySuccess.vue?vue&type=script&lang=js&"
export * from "./SgQuickPaySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports